import { AuthApi } from "@/api/auth";
import { LoginRequest } from "@/api/auth/types";
import { LocalStorageService, ROUTE } from "@/utils";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export const useLogin = () => {
  const navigate = useNavigate();

  const { mutate: login, isPending: isLoginLoading } = useMutation({
    mutationFn: (body: LoginRequest) => AuthApi.login(body),
    onSuccess: ({ tokens }) => {
      LocalStorageService.setRefreshToken(tokens.refreshToken);
      LocalStorageService.setAccessToken(tokens.accessToken);

      toast.success("Login successfully!");
      navigate(ROUTE.DASHBOARD);
    },
    onError: (error) => {
      toast.error(error);
    },
  });

  return { login, isLoginLoading };
};
